//
// StringValue.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./AbstractValueType";
import "../DynamicValue";
import "./ValueBehavior";
import "../../dataDefinition/DataItemOrPromptDefinition";
import "@sas-dvr/ltjs-commons/models/data/dataset/DataUsage";

var StringValue = createModule("BIRD::StringValue", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::AbstractValueType"], EventDispatcher, [
    ,
    {
        valueRef: 1,
        dynamicValue: 4,
        behavior: 4,
        value: 7,
    },
    ,
    ,
    {
        getDataUsage: [4],
    },
    {
        _create: [4],
    },
    ,
]);
export default StringValue;
